import { render } from "./ClientList.vue?vue&type=template&id=1149fc73"
import script from "./ClientList.vue?vue&type=script&lang=js"
export * from "./ClientList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__